import { Button, Form, Modal, notification } from 'antd'
import { FC } from 'react'
import useForm from '../hooks/use-form'
import { useCreateStampMutation } from '../../../../store/api/stamps-api'
import Stamp from '../../../../types/api/stamp'
import FormValues from '../types/form-values'
import { StrapiCreate } from '../../../../types/strapi/strapi'

interface UseNewButtonProps {
    onSelect: (stamp: Stamp) => void
}

const UseNewButton: FC<UseNewButtonProps> = ({ onSelect }) => {
    const form = useForm()
    const [createStamp] = useCreateStampMutation()

    const getStampProperties = (): StrapiCreate<Stamp> => {
        const values = form.getFieldsValue() as Required<FormValues>
        const rollerInfo = JSON.parse(values.roller)

        return {
            data: {
                width: values.width,
                length: values.length,
                roller: rollerInfo.roller ? { set: [rollerInfo.roller] } : undefined,
                floods: values.floods,
                shape: values.shape,
                number: '',
                quantity: 0,
                range: rollerInfo.distance as number,
                code: '',
                locked: false,
                // tube?: Tube // TODO: подумать сразу ли искаль и присваевать тубу под него или нет
                externalId: '',
            },
        }
    }

    const onClick = async () => {
        try {
            await form.validateFields()
            const res = await createStamp(getStampProperties())

            if (res.data) {
                notification.success({ message: 'Новый штамп создан' })
                onSelect(res.data.data)
            } else {
                Modal.error({ title: 'Ошибка создания штампа', content: JSON.stringify(res.error) })
            }
        } catch (e) {
            console.error(e)
        }
    }

    return (
        <Form.Item label={' '}>
            <Button type={'primary'} onClick={onClick}>
                Использовать новый
            </Button>
        </Form.Item>
    )
}

export default UseNewButton
